/*
    创建者：shuxiaokai
    创建时间：2020-05-06 16:06
    模块名称：拖拽组件
    备注：xxxx
*/
<template>
    <div
            @mousedown.stop="handleMouseDown"
            @mouseup.stop="handleMouseUp"
            @contextmenu.stop.prevent="handleContextmenu"
            @click.stop="handleGlobalClick"
    >
        <s-resize-bar v-if="selectWidgetId && selectWidgetId === id"></s-resize-bar>
        <s-context-menu v-show="isShowContextMenu" :left="contextX" :top="contextY">
            <slot name="contextmenu" />
        </s-context-menu>
        <slot />
    </div>
</template>

<script>
import resizeBar from "@/pages/model/f/components/resize-bar"
import contextMenu from "@/pages/model/f/components/context-menu"
export default {
    components: {
        "s-resize-bar": resizeBar,
        "s-context-menu": contextMenu
    },
    props: {
        id: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            contextX: 0, //点击右键x位置
            contextY: 0, //点击右键y位置
            isShowContextMenu: false, //是否显示contextmenu
        };
    },
    computed: {
        currentWidget() {
            return this.$store.state.widget.widgetList.find(val => val.id === this.id);
        },
        selectWidgetId() {
            return this.$store.state.widget.selectWidgetId;
        }
    },
    beforeDestroy() {
        //document.documentElement.removeEventListener("mouseup", this.handleMouseUp);
    },
    mounted() {
        document.documentElement.addEventListener("mouseup", this.handleMouseUp);
        document.documentElement.addEventListener("click", this.handleGlobalClick);
        
    },
    methods: {
        //=====================================获取远程数据==================================//

        //=====================================前后端交互====================================//

        //=====================================组件间交互====================================//  
        //鼠标按下
        handleMouseDown(e) {
            if (e.which !== 1) { //非鼠标左键不做处理
                return;
            }
            this.offsetLeft = e.clientX - this.currentWidget.boundingClientRect.left;
            this.offsetTop = e.clientY - this.currentWidget.boundingClientRect.top;
            document.documentElement.addEventListener("mousemove", this.handleMouseMove);
        },
        //鼠标移动
        handleMouseMove(e) {
            e.stopPropagation();
            const left = e.clientX;
            const top = e.clientY;
            this.$store.commit("changeWidgetBoundingClientRect", {
                id: this.id,
                left: left - this.offsetLeft,
                top: top - this.offsetTop,
            });
        },
        //鼠标松开
        handleMouseUp(e) {
            this.$emit("mouseup", e)
            document.documentElement.removeEventListener("mousemove", this.handleMouseMove);
        },
        //鼠标右键
        handleContextmenu(e) {
            this.isShowContextMenu = true
            this.contextX = e.clientX;
            this.contextY = e.clientY;
        },
        //全局鼠标点击
        handleGlobalClick(e) {
            e.stopPropagation();
            this.isShowContextMenu = false;
        },
        //=====================================其他操作=====================================//

    }
};
</script>



<style lang="scss">

</style>
